import { render, staticRenderFns } from "./NotificationCardForEventComment.vue?vue&type=template&id=2457c2d0&scoped=true&"
import script from "./NotificationCardForEventComment.vue?vue&type=script&lang=js&"
export * from "./NotificationCardForEventComment.vue?vue&type=script&lang=js&"
import style0 from "./NotificationCardForEventComment.vue?vue&type=style&index=0&id=2457c2d0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2457c2d0",
  null
  
)

export default component.exports